import { splitEmails } from '@/utils'
import { emailValidation } from '@/mixins/validateEmail'
import { createBackendErrorHandler } from '@/utils/errorMessages'
import * as invitationsErrors from '@/mixins/errors/invitations'
import * as permissionsErrors from '@/utils/errors/permissions'

const { getBackendErrorMessage } = createBackendErrorHandler(invitationsErrors, permissionsErrors)

export const inviteEmails = {
    mixins: [emailValidation],
    data() {
        return {
            error: false,
            emailsInput: '',
            emailsData: [],
            emailList: [],
            failedInvitations: [],
            invitationErrorContent: '',
            inviting: false,
            valid: false,
            generateInvitationLinksOnly: 0,
            numInvitationsToSend: 0
        }
    },
    computed: {
        emails() {
            if (this.validatedEmails.length) {
                return this.validatedEmails
            }
            if (this.emailsData.length) {
                return this.emailsData
            }
            return []
        },
        showInvitationErrorsDialog() {
            return this.foundInvalidEmails || this.backendError || this.emailsValidationError
        },
        validationErrorType() {
            if (this.foundInvalidEmails) {
                return this.emailValidationErrorTypes.INVALID_EMAILS_ERROR
            }
            if (this.backendError || this.emailsValidationError) {
                return this.emailValidationErrorTypes.EMAIL_VALIDATION_BACKEND_ERROR
            }
            return null
        },
        inviteActionInProgress() {
            return this.numInvitationsToSend > 0 || this.validatingEmails
        }
    },
    methods: {
        updateEmailString() {
            this.validatedEmails = []
            const emails = splitEmails(this.emailsInput)
            this.emailsData = emails
            this.emailList = emails.map(email => email.email)
        },
        resetInviteEmailsForm() {
            this.error = false
            this.emailsInput = ''
            this.emailsData = []
            this.emailList = []
            this.failedInvitations = []
            this.inviting = false
            this.generateInvitationLinksOnly = 0
            this.numInvitationsToSend = 0
            this.setEmailValidationDefaultData()
            if (this.$refs.inviteEmailsInput) {
                this.$refs.inviteEmailsInput.resetValidation()
            }
            if (this.$refs.inviteEmailsForm) {
                this.$refs.inviteEmailsForm.resetValidation()
            }
        },
        inviteUsers(confirmed) {
            if (!confirmed) {
                return
            }

            this.error = false
            this.failedInvitations = []
            this.invitationErrorContent = ''
            this.$store.dispatch('showSnackBar', {
                snackBarText: 'Inviting users...',
                snackBarTimeout: 5000,
                snackBarIcon: 'info'
            })
            this.inviting = true
            this.numInvitationsToSend = this.emailList.length

            this.emailList.forEach(email => {
                const postBody = { requestee_email: email, generate_link_only: this.generateInvitationLinksOnly }
                this.$axios
                    .post(this.requestUrl, postBody, { timeout: 300000 })
                    .catch(error => {
                        this.failedInvitations.push(email)
                        this.error = true
                        const invitationErrorContent = getBackendErrorMessage(error, '')
                        if (invitationErrorContent) this.invitationErrorContent = invitationErrorContent
                    })
                    .finally(() => {
                        this.numInvitationsToSend -= 1
                        if (this.numInvitationsToSend === 0) {
                            this.inviting = false
                            if (!this.error) {
                                this.$store.dispatch('showSnackBar', {
                                    snackBarText: 'Invitations have been successfully sent',
                                    snackBarTimeout: 5000,
                                    snackBarIcon: 'check_circle'
                                })
                                this.resetInviteEmailsForm()
                            }
                        }
                    })
            })
        },
        validateEmailsAndInviteUsers(confirmed) {
            if (!confirmed) {
                return
            }

            this.validateEmails(this.emailList).finally(() => {
                if (!this.emailsValidationError && !this.backendError && !this.foundInvalidEmails) {
                    this.inviteUsers(true)
                }
            })
        }
    }
}
